import React from "react";
import { EntrydateContainer } from "../../../containers";

const Entrydate = (props) => {
  return <EntrydateContainer {...props} />;
};

export default Entrydate;
